/**
 * Colores para estados y sub-estados de reservas
 * Centralizados para mantener consistencia en toda la aplicación
 */

export const ESTADO_COLORS = {
  'activo': 'blue',
  'inactivo': 'yellow',
  'cancelado': 'red'
};

export const SUB_ESTADO_COLORS = {
  'pendiente_pago': 'yellow',
  'bolsa': 'blue',
  'asignada_espera': 'blue',
  'en_curso': 'blue',
  'completado': 'teal',
  'completado_sin_confirmar': 'blue',
  'finalizado': 'yellow',
  'pendiente_devolucion': 'blue',
  'fallido': 'yellow',
  'cancelado_cliente': 'red',
  'cancelado_administrador': 'red',
  'cancelado_automatico': 'red'
};

/**
 * Obtiene el color para un estado dado
 */
export const getEstadoColor = (estado) => {
  return ESTADO_COLORS[estado] || 'gray';
};

/**
 * Obtiene el color para un sub-estado dado
 */
export const getSubEstadoColor = (subEstado) => {
  return SUB_ESTADO_COLORS[subEstado] || 'gray';
};
